export default "__VITE_ASSET__B3HTc6YF__"